import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.508 8 4.29 14.294a1.006 1.006 0 0 0 .32 1.63.98.98 0 0 0 1.077-.217l6.916-7a1.006 1.006 0 0 0 0-1.414l-6.916-7a.98.98 0 0 0-1.397 0 1.006 1.006 0 0 0 0 1.413z" }));
const ForwardRef = forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
